module.exports = __webpack_public_path__ + "img/vip.1c399514.png";